import { makeObservable, action, observable } from "mobx";
import { BrowserStorage } from "utils/BrowserStorage";

const M_POSITIONS = "M_POSITIONS";

export interface ModalPosition {
  top: number;
  left: number;
}

export class ModalPositionsStore {
  data: { [key: string]: ModalPosition } = {};
  constructor() {
    makeObservable(this, {
      data: observable,
      initPositions: action.bound,
      setPosition: action.bound,
    });
    this.initPositions();
  }

  clear() {
    this.data = {};
  }

  initPositions() {
    const data = BrowserStorage.get(M_POSITIONS);
    if (data) {
      try {
        this.data = JSON.parse(data);
      } catch (error) {
        console.error("Failed to parse JSON:", data);
      }
    }
  }

  setPosition(uid: string, position: ModalPosition) {
    this.data[uid] = { ...position };
    this.save();
  }

  getPosition(uid: string) {
    if (this.data[uid]) {
      return { ...this.data[uid] };
    } else {
      return undefined;
    }
  }

  save() {
    const payload = JSON.stringify(this.data);
    BrowserStorage.store(M_POSITIONS, payload);
  }
}

export const modalPositionsStore = new ModalPositionsStore();
